import { useMediaQuery } from '@mui/material';
import { mediaQueryResolutions } from '../config';

interface UseDesktop {
  matchesMD: boolean,
  minHeigth: boolean,
}

export const useDesktopMediaQuery = (): UseDesktop => {
  const minWidth = useMediaQuery(mediaQueryResolutions.desktopMinWidthResolution);
  const minHeigth = useMediaQuery(mediaQueryResolutions.desktopMinHeightResolution);
  const matchesMD = minWidth && minHeigth;
  return {
    matchesMD,
    minHeigth,
  };
};
